//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Positioning.js";
import "../no/NXObject.js";
let d=[[],[[["num_constraints"],"GetMemberConstraints",{R_:{constraints:"Positioning.ComponentConstraint[]"}},0,0],[["num_constraints"],"GetDefiningConstraints",{R_:{constraints:"Positioning.ComponentConstraint[]"}},0,0],[["constraints"],"SetDefiningConstraints",{},1,0],[["num_components"],"GetDefiningComponents",{R_:{components:"Assemblies.Component[]"}},0,0],[["constraints"],"SetDefiningComponents",{},1,0],[[],"GetConstraintCollectionType",{R_:{constraintCollectionType:''}},0,0],[["constraintCollectionType"],"SetConstraintCollectionType",{},1,0],[[],"GetRememberComponentState",{R_:{rememberComponentState:''}},0,0],[["rememberComponentState"],"SetRememberComponentState",{},1,0],[[],"UpdateMemberConstraints",{R_:{changed:''}},0,0]],[]];
SPLM.Positioning.ComponentConstraintGroup = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Positioning.ComponentConstraintGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Positioning.ComponentConstraintGroup.ConstraintsCollectionType = Object.freeze({
    "BetweenSelectedComponents" : "BetweenSelectedComponents", "ConnectedToSelectedComponents" : "ConnectedToSelectedComponents"});

export default SPLM;